import { createAction, handleActions } from "redux-actions"
import {
  buildRefreshParameters,
  getTabularReducerInfo,
} from "./tabularData/common"
import { apiDelete, apiGet, apiPost, apiPut } from "../utils/apiConnector"
import { saleApi, cashboxApi, toFiscalApi } from "../config/apiUrls"
import { forEachObjIndexed } from "ramda"
import { alertTypes, showMessage } from "./alerts"

// Default state
const defaultState = {
  isLoading: false,
  data: [],
  loadingCashboxIds: [],
}

// Action Creators
/// setLoading(flag)
const setLoading = createAction("SET_CASHBOX_FETCHING")
const edit = createAction("EDIT_CASHBOX")
/// setEmployees(employees)
const setCashbox = createAction("SET_CASHBOX")
/// removeEmployee(employeeId)
const removeCashbox = createAction("REMOVE_CASHBOX")

const setCashboxLoading = createAction("SET_CASHBOX_LOADING", (id, flag) => ({
  id,
  flag,
}))
// Reducer
const reducer = handleActions(
  {
    [setLoading]: (state, { payload }) => ({ ...state, isLoading: payload }),
    [setCashbox]: (state, { payload }) => ({ ...state, data: payload }),
    [edit]: (state, { payload }) => ({ ...state }),
    [removeCashbox]: (state, { payload }) => ({
      ...state,
      data: state.data.filter((e) => e.id !== payload),
    }),
    [setCashboxLoading]: (state, { payload: { id, flag } }) => {
      if (flag) {
        return {
          ...state,
          loadingCashboxIds: [...state.loadingCashboxIds, id],
        }
      } else {
        return {
          ...state,
          loadingCashboxIds: state.loadingCashboxIds.filter((l) => l !== id),
        }
      }
    },
  },
  defaultState,
)
export default reducer

// Thunk
export function refresh() {
  return (dispatch, getState) => {
    const state = getState()
    const storeId =
      (state.profile.currentStore && state.profile.currentStore.id) ||
      (state.profile.stores.length > 0 && state.profile.stores[0].id)
    dispatch(setLoading(true))
    return apiGet(cashboxApi, { storeId })
      .onOk((res) => {
        dispatch(
          setCashbox(
            res.data.response.cashboxes.map((s) => ({
              storeAddress: s.storeAddress,
              storeName: s.storeName,
              disabled: s.disabled,
              id: s.id,
              isFiscal: s.isFiscal,
              name: s.name,
              fiscal: s.fiscal,
              isMinus: s.isMinus,
            })),
          ),
        )
        // dispatch(actions.setTotalPages(res.data.response.pages))
        // dispatch(actions.setTotalCount(res.data.response.count))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        dispatch(setLoading(false))
      })
      .startSingle()
  }
}

export function deleteCashbox(id) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(setCashboxLoading(id, true))
    apiDelete(cashboxApi, { cashboxId: id })
      .onOk(() => {
        dispatch(removeCashbox(id))
        dispatch(showMessage("Касса успешно удалена!", alertTypes.success))
        dispatch(refresh())
        // dispatch(showMessage("Касса успешно удалена!", alertTypes.success)),
        //   dispatch(refresh())
      })
      .afterAll(() => {
        dispatch(setCashboxLoading(id, false))
      })
      .useDefaultErrorHandlers(dispatch)
      .start()
  }
}

export function editCashbox(editedData) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(setCashboxLoading(editedData.id, true))
    apiPut(cashboxApi, editedData)
      .onOk(() => {
        dispatch(refresh())
        dispatch(
          showMessage("Касса успешно отредактирована!", alertTypes.success),
        )
        dispatch(edit())
      })
      .afterAll(() => {
        dispatch(setCashboxLoading(editedData.id, false))
      })
      .useDefaultErrorHandlers(dispatch)
      .start()
  }
}

export function fiscalCashbox(data) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    apiPut(toFiscalApi, data)
      .onOk((res) => {
        dispatch(
          showMessage("Касса успешно фискализирована!", alertTypes.success),
        )
        dispatch(refresh())
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

export function createCashbox(editedData) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(setLoading(true))
    apiPost(cashboxApi, editedData)
      .onOk(() => {
        dispatch(showMessage("Касса успешно добавлена!", alertTypes.success))
        dispatch(setCashbox({}))
        dispatch(refresh())
      })
      .afterAll(() => {
        dispatch(setLoading(false))
      })
      .useDefaultErrorHandlers(dispatch)
      .start()
  }
}

// export function editSale(editedData) {
//   // eslint-disable-next-line no-empty-pattern
//   return (dispatch, {}) => {
//     forEachObjIndexed((data, id) => {
//       apiPut(saleApi + "/" + id, data)
//         .onOk(() => {
//           dispatch(
//             showMessage("Товар успешно отредактирован", alertTypes.success),
//           )
//         })
//         .useDefaultErrorHandlers(dispatch)
//         .start()
//     }, editedData)
//   }
// }
